<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      profile: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        logo: require('@/assets/logo.png'),
        items: [
          {
            label: this.$t("message.lesson.title"),
            icon:'pi pi-fw pi-book',
            visible: () => this.profile.roles.includes('owner'),
            command: () => this.$router.push({ name: 'OwnerLesson' }),
            routeName: 'OwnerLesson'
          },
          {
            label: (this.profile.partners && this.profile.partners[0]) ? this.profile.partners[0] : this.$t("message.lesson.title"),
            icon:'pi pi-fw pi-sitemap',
            visible: () => this.profile.roles.includes('owner') || this.profile.roles.includes('admin'),
            command: () => this.$router.push({ name: 'OwnerEmployee' }),
            routeName: 'OwnerEmployee'
          },
          {
            label: this.$t("message.partner.title"),
            icon:'pi pi-fw pi-sitemap',
            visible: () => this.profile.roles.includes('superadmin'),
            items:[
                {
                  label: this.$t("message.partner.add"),
                  command: () => this.$router.push({ name: 'AddPartner' }),
                  routeName: 'AddPartner'
                },
                {
                  label: this.$t("message.partner.list"),
                  command: () => this.$router.push({ name: 'Partner' }),
                  routeName: 'Partner'
                }
            ]
          },
          {
            label: this.$t("message.lesson.title"),
            icon:'pi pi-fw pi-book',
            visible: () => this.profile.roles.includes('superadmin'),
            items:[
                {
                  label: this.$t("message.lesson.add"),
                  command: () => this.$router.push({ name: 'AddLesson' }),
                  routeName: 'AddLesson'
                },
                {
                  label: this.$t("message.lesson.list"),
                  command: () => this.$router.push({ name: 'Lesson' }),
                  routeName: 'Lesson'
                }
            ]
          },
          {
            label: this.$t("message.user.title"),
            icon:'pi pi-fw pi-users',
            visible: () => this.profile.roles.includes('superadmin'),
            items:[
              {
                label: this.$t("message.user.add"),
                command: () => this.$router.push({ name: 'AddUser' }),
                routeName: 'AddUser'
              },
              {
                label: this.$t("message.user.list"),
                command: () => this.$router.push({ name: 'User' }),
                routeName: 'User'
              }
            ]
          },
          {
            label: this.$t("message.settings.title"),
            icon:'pi pi-fw pi-cog',
            visible: () => this.profile.roles.includes('superadmin'),
            items:[
              {
                label: this.$t("message.settings.category"),
                command: () => this.$router.push({ name: 'SettingCategory' }),
                routeName: 'SettingCategory'
              },
              {
                label: this.$t("message.settings.department"),
                command: () => this.$router.push({ name: 'SettingDepartment' }),
                routeName: 'SettingDepartment'
              },
              {
                label: this.$t("message.settings.faq"),
                command: () => this.$router.push({ name: 'SettingFAQ' }),
                routeName: 'SettingFAQ'
              },
              {
                label: this.$t("message.settings.assessment"),
                command: () => this.$router.push({ name: 'Assessment' }),
                routeName: 'Assessment'
              },
              {
                label: this.$t("message.settings.reset_user"),
                command: () => this.$router.push({ name: 'ResetUser' }),
                routeName: 'ResetUser'
              }
            ]
          },
          {
            label: this.$t("message.settings.faq"),
            icon:'pi pi-question-circle',
            visible: () => !this.profile.roles.includes('superadmin'),
            command: () => this.$router.push({ name: 'FAQ' }),
            routeName: 'FAQ'
          },
          {
            label: this.profile.first_name,
            icon:'pi pi-fw pi-user',
            items:[
              {
                label: this.$t("message.profile.edit"),
                command: () => this.$router.push({ name: 'Profile' }),
                routeName: 'Profile'
              },
              {
                label: this.$t("message.profile.changeLanguage"),
                command: () => this.changeLanguage()
              },
              {
                label: this.$t("message.auth.signout"),
                command: () => this.signOut()
              }
            ]
          }
        ],
        currentRouteName: null
      }
    },
    watch:{
      $route(to) {
        this.currentRouteName = to.name;
      }
    },
    computed:{
      ...mapGetters([
        'authenticated'
      ])
    },
    methods:{
      changeLanguage(){
        this.$store.dispatch('changeLanguage', this.$i18n).then(() => {
          // refresh menuitems
          this.items = [
            {
              label: this.$t("message.lesson.title"),
              icon:'pi pi-fw pi-book',
              visible: () => this.profile.roles.includes('owner'),
              command: () => this.$router.push({ name: 'OwnerLesson' }),
              routeName: 'OwnerLesson'
            },
            {
              
              label: (this.profile.partners && this.profile.partners[0]) ? this.profile.partners[0] : this.$t("message.lesson.title"),
              icon:'pi pi-fw pi-sitemap',
              visible: () => this.profile.roles.includes('owner') || this.profile.roles.includes('admin'),
              command: () => this.$router.push({ name: 'OwnerEmployee' }),
              routeName: 'OwnerEmployee'
            },
            {
              label: this.$t("message.partner.title"),
              icon:'pi pi-fw pi-sitemap',
              visible: () => this.profile.roles.includes('superadmin'),
              items:[
                  {
                    label: this.$t("message.partner.add"),
                    command: () => this.$router.push({ name: 'AddPartner' }),
                    routeName: 'AddPartner'
                  },
                  {
                    label: this.$t("message.partner.list"),
                    command: () => this.$router.push({ name: 'Partner' }),
                    routeName: 'Partner'
                  }
              ]
            },
            {
              label: this.$t("message.lesson.title"),
              icon:'pi pi-fw pi-book',
              visible: () => this.profile.roles.includes('superadmin'),
              items:[
                  {
                    label: this.$t("message.lesson.add"),
                    command: () => this.$router.push({ name: 'AddLesson' }),
                    routeName: 'AddLesson'
                  },
                  {
                    label: this.$t("message.lesson.list"),
                    command: () => this.$router.push({ name: 'Lesson' }),
                    routeName: 'Lesson'
                  }
              ]
            },
            {
              label: this.$t("message.user.title"),
              icon:'pi pi-fw pi-users',
              visible: () => this.profile.roles.includes('superadmin'),
              items:[
                {
                  label: this.$t("message.user.add"),
                  command: () => this.$router.push({ name: 'AddUser' }),
                  routeName: 'AddUser'
                },
                {
                  label: this.$t("message.user.list"),
                  command: () => this.$router.push({ name: 'User' }),
                  routeName: 'User'
                }
              ]
            },
            {
              label: this.$t("message.settings.title"),
              icon:'pi pi-fw pi-cog',
              visible: () => this.profile.roles.includes('superadmin'),
              items:[
                {
                  label: this.$t("message.settings.category"),
                  command: () => this.$router.push({ name: 'SettingCategory' }),
                  routeName: 'SettingCategory'
                },
                {
                  label: this.$t("message.settings.department"),
                  command: () => this.$router.push({ name: 'SettingDepartment' }),
                  routeName: 'SettingDepartment'
                },
                {
                  label: this.$t("message.settings.faq"),
                  command: () => this.$router.push({ name: 'SettingFAQ' }),
                  routeName: 'SettingFAQ'
                },
                {
                  label: this.$t("message.settings.assessment"),
                  command: () => this.$router.push({ name: 'Assessment' }),
                  routeName: 'Assessment'
                },
                {
                  label: this.$t("message.settings.reset_user"),
                  command: () => this.$router.push({ name: 'ResetUser' }),
                  routeName: 'ResetUser'
                }
              ]
            },
            {
              label: this.$t("message.settings.faq"),
              icon:'pi pi-question-circle',
              visible: () => !this.profile.roles.includes('superadmin'),
              command: () => this.$router.push({ name: 'FAQ' }),
              routeName: 'FAQ'
            },
            {
              label: this.profile.first_name,
              icon:'pi pi-fw pi-user',
              items:[
                {
                  label: this.$t("message.profile.edit"),
                  command: () => this.$router.push({ name: 'Profile' }),
                  routeName: 'Profile'
                },
                {
                  label: this.$t("message.profile.changeLanguage"),
                  command: () => this.changeLanguage()
                },
                {
                  label: this.$t("message.auth.signout"),
                  command: () => this.signOut()
                }
              ]
            }
          ]
        })
      },
      signOut(){
        this.$store.dispatch('revokeToken').then(() => {
          this.$router.push({name: 'SignIn'})
        }).catch(() => {

        })
      }
    }
  }
</script>

<template>
  <div class="container px-4 m-auto">
    <Menubar v-if="authenticated" :model="items" class="custom-toolbar" zIndex="9999">
      <template #start>
        <Image :src="logo" alt="Logo" width="250" class="logo" @click="$router.push({ name: 'Dashboard' })" />
      </template>
      <template #item="{ item }">
        <div class="cursor-pointer">
          <div class="flex items-center gap-1.5 p-2" :class="{ 'text-yellow-500': currentRouteName === item.routeName }">
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </template>
    </Menubar>
  </div>
</template>

<style lang="scss">
  .custom-toolbar{
    background-color: transparent !important;
    // background-color: $toolbar !important;
    border-radius: unset !important;
    justify-content: space-between;
    padding: 5px !important;
    border: none !important;
    .p-menubar-root-list .p-menuitem{
      .p-menuitem-link{
        &:focus{
          box-shadow: none !important;
        }
        &:hover span{
          color: $menu-mobile !important;
        }
        span{
          color: $yellow-theme !important;
        }
      }
    }
    .p-submenu-list{
      width: 100% !important;
    }
    .p-menubar-item{
      &.p-focus > .p-menubar-item-content{
        background: none !important;
      }
      .p-menubar-item-content{
        // background-color: red !important;
        color: white !important;
        user-select: none;
        &:hover{
          background: none !important;
          color: $yellow-theme !important;
        }
      }
      .p-menubar-submenu{
        background: $toolbar;
      }
    }
    .p-menubar-item-active > .p-menubar-item-content{
      background: none !important;
    }
  }
</style>

<style lang="scss" scoped>
  .logo{
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  }
</style>